/**
 * Componente StatusBadge - ConfereAI
 *
 * Badge de status padronizado para o sistema.
 * Baseado no layout da página de Veículos.
 */

import React from 'react';
import './StatusBadge.css';

export type StatusType =
  | 'Ativo'
  | 'Inativo'
  | 'Manutenção'
  | 'Pendente'
  | 'Concluído'
  | 'Atrasado'
  | 'Em Andamento'
  | 'Cancelado';

interface StatusBadgeProps {
  status: string;
  className?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className = '' }) => {
  const getStatusClass = (status: string): string => {
    // Normaliza o status para lowercase para comparação
    const statusLower = status.toLowerCase();

    const statusMap: Record<string, string> = {
      // Valores do banco (lowercase) e variações capitalizadas
      'ativo': 'status-active',
      'inativo': 'status-inactive',
      'manutencao': 'status-maintenance',
      'manutenção': 'status-maintenance',
      'pendente': 'status-pending',
      'concluido': 'status-completed',
      'concluído': 'status-completed',
      'atrasado': 'status-delayed',
      'em andamento': 'status-pending',
      'cancelado': 'status-inactive',
      'resolvida': 'status-completed',
      'em_andamento': 'status-pending',
    };

    return statusMap[statusLower] || 'status-pending';
  };

  return (
    <span className={`status-badge ${getStatusClass(status)} ${className}`}>
      {status}
    </span>
  );
};

export default StatusBadge;
